// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "bundle." + "paella" + "." + "35e85bf284a4832dc86e" + ".js";
};